export default __webpack_public_path__ + "static/media/info-page-privacy.c1670372.png";